module.exports = __webpack_public_path__ + "static/media/schrank_ohne_flasche_ohne_etiket.3c44045a.jpg";